import { getConversationById } from '@app/helpers'
import { isBuyerView } from '@app/utils'

import { ChatState } from '../types'

export const onOpenConversation = (
  state: ChatState,
  conversationId: number
): ChatState => {
  if (isBuyerView()) {
    return state
  }

  const conversation = getConversationById(state.conversations, conversationId)
  if (!conversation || !conversation.unread) {
    return state
  }

  const unreadList = state.unreadList.filter((id) => id !== conversationId)

  return {
    ...state,
    unreadList,
    unreadTotal: Math.max(0, state.unreadTotal - 1),
    conversations: {
      ...state.conversations,
      [conversationId]: { ...conversation, unread: false },
    },
  }
}
